import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AssetService } from '../../../../../services/asset/asset.service';

/**
 * Routed host for the stream-config editor.
 *
 * It only decides *which* editor to show: assets that carry no schemaVersion (or
 * schemaVersion 1) open in the old-model v1 editor; schemaVersion 2 opens the new
 * flow v2 editor. A selector lets the user switch between the two — defaulting to
 * v1 — and the chosen child (app-asset-config-v1 / -v2) loads the asset itself
 * from the shared :id route param.
 */
@Component({
  selector: 'app-asset-config',
  templateUrl: './host.component.html',
  styleUrls: ['./host.component.scss']
})
export class AssetConfigComponent implements OnInit, OnDestroy {

  assetPath = '';
  /** 1 = old model (v1 editor), 2 = new flow (v2 editor). null while detecting. */
  schemaVersion: number | null = null;
  private sub: any = null;

  constructor(private route: ActivatedRoute, private svc: AssetService) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe((p: Params) => {
      this.assetPath = p['id'];
      this.detectSchemaVersion();
    });
  }

  ngOnDestroy() {
    if (this.sub) { this.sub.unsubscribe(); this.sub = null; }
  }

  get isV2(): boolean {
    return this.schemaVersion === 2;
  }

  /** Reads the saved config to pick the matching editor; legacy/no config → v1. */
  private detectSchemaVersion() {
    this.svc.getConfig(this.assetPath).subscribe(
      (response: any) => {
        let version = 1; // legacy assets carry no schemaVersion → old model
        if (response && response.data && response.data.config_data) {
          try {
            const raw = JSON.parse(response.data.config_data);
            if (raw && Number(raw.schemaVersion) === 2) version = 2;
          } catch (_) {}
        }
        this.schemaVersion = version;
      },
      (_err: any) => {
        // No saved config yet → start on the old model; user can switch to v2.
        this.schemaVersion = 1;
      }
    );
  }

  setSchemaVersion(version: number | string) {
    this.schemaVersion = Number(version) === 2 ? 2 : 1;
  }
}
